import {
    GET_COMPANY_USERS,
    GET_COMPANY_USERS_SUCCESS,
    GET_COMPANY_USERS_FAIL,
    ADD_NEW_COMPANY_USER,
    ADD_NEW_COMPANY_USER_SUCCESS,
    ADD_NEW_COMPANY_USER_FAIL,
    UPDATE_COMPANY_USER,
    UPDATE_COMPANY_USER_SUCCESS,
    UPDATE_COMPANY_USER_FAIL,
    DELETE_COMPANY_USER,
    DELETE_COMPANY_USER_SUCCESS,
    DELETE_COMPANY_USER_FAIL,
} from "./actionTypes"

export const getCompanyUsers = () => ({
    type: GET_COMPANY_USERS,
})

export const getCompanyUsersSuccess = users => ({
    type: GET_COMPANY_USERS_SUCCESS,
    payload: users,
})

export const getCompanyUsersFail = error => ({
    type: GET_COMPANY_USERS_FAIL,
    payload: error,
})

export const addNewCompanyUser = user => ({
    type: ADD_NEW_COMPANY_USER,
    payload: user,
})

export const addNewCompanyUserSuccess = user => ({
    type: ADD_NEW_COMPANY_USER_SUCCESS,
    payload: user,
})

export const addNewCompanyUserFail = error => ({
    type: ADD_NEW_COMPANY_USER_FAIL,
    payload: error,
})

export const updateCompanyUser = user => ({
    type: UPDATE_COMPANY_USER,
    payload: user,
})

export const updateCompanyUserSuccess = user => ({
    type: UPDATE_COMPANY_USER_SUCCESS,
    payload: user,
})

export const updateCompanyUserFail = error => ({
    type: UPDATE_COMPANY_USER_FAIL,
    payload: error,
})

export const deleteCompanyUser = user => ({
    type: DELETE_COMPANY_USER,
    payload: user,
})

export const deleteCompanyUserSuccess = user => ({
    type: DELETE_COMPANY_USER_SUCCESS,
    payload: user,
})

export const deleteCompanyUserFail = error => ({
    type: DELETE_COMPANY_USER_FAIL,
    payload: error,
})
